// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import rem from '../static/js/flexible.js' //rem转换
import http from './api/httpList.js'  //ajax请求
import signature from './api/signature.js'
import tool from './api/motheds.js'  //工具
import popup from './api/popup.js'  //工具
import title from 'vue-wechat-title'  //工具
import wxtools from './api/wx.js'
import Vant from 'vant';
import 'vant/lib/index.css';
import '@vant/touch-emulator';
import * as filter from './api/filter.js' //公共过滤器
import stort from "./api/stort.js";
Vue.config.productionTip = false
//公共sass文件
import './sass/helper/_variables.scss';
import './sass/helper/_function.scss';

Vue.use(rem)
// Vue.use(ajax)
Vue.use(http)
Vue.use(signature)
Vue.use(tool)
Vue.use(popup)
Vue.use(filter)
Vue.use(title)
Vue.use(wxtools)
Vue.use(Vant);

const filters = filter.filter;
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = binding.value;
  },
  update:function (el, binding) {
    document.title = binding.value;
  }
});
// 将API方法绑定到全局
// Vue.prototype.$ajax = ajax
Vue.prototype.$http = http
Vue.prototype.$signature = signature
Vue.prototype.$tool = tool
Vue.prototype.$popup = popup
Vue.prototype.$stort = stort
Vue.prototype.$wxtools = wxtools
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js